import ColumnsContent from '../../../../../../components/Hocs/ColumnsContent';
import ContentView from './ContentView';
import RightSidebar from '../RightSidebar/RightSidebar';

export default ColumnsContent(ContentView, RightSidebar);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Help/ReferenceInformation/ContentView/index.js